export const __PROD__ = process.env.REACT_APP_ENV === 'production';
export const __CRUCIBLE_IMAGE_LOADING =
  'https://crucible-placeholders.storage.googleapis.com/loading.png';
export const __CRUCIBLE_IMAGE_UNAVAILABLE =
  'https://crucible-placeholders.storage.googleapis.com/placeholder.png';
export const __CRUCIBLE_IMAGE_UNREVEALED =
  'https://crucible-placeholders.storage.googleapis.com/unrevealed.png';
